import {Node} from "../Node";
import {AbstractUploadProperty} from "./AbstractUploadProperty";

export class PModel3d extends AbstractUploadProperty<Node> {

    constructor(args) {
        super({
            type: 'Model3d',
            ...args
        });
    }

    get showBig() {
        return this.get() != null;
    }

}
